import React from 'react';
import Button from '@material-ui/core/Button';

import { translation } from '../../../_helpers/Translate';
import { DEFAULT_FILTER } from '../../../components/TableFilter/useTableFilter';

const styles = {
  textAlign: 'center'
};

export const notificationsColumns = ({ pageNumber, lang, onAnnul, onChangeAddress }) => {
  return [
    {
      Header: '№',
      width: 60,
      style: styles,
      Cell: row => (pageNumber - 1) * DEFAULT_FILTER.pageSize + row.index + 1
    },
    {
      Header: translation('supplierDataChange_columnName'),
      accessor: lang === 'kk' ? 'serviceProviderKkName' : 'serviceProviderRuName',
      style: styles
    },
    {
      Header: translation('supplierDataChange_columnBin'),
      accessor: 'serviceProviderBin',
      width: 160,
      style: styles
    },
    {
      Header: translation('supplierDataChange_designCapacity'),
      accessor: 'designCapacity',
      width: 160,
      style: styles
    },
    {
      Header: translation('supplierDataChange_legalAddress'),
      accessor: 'legalAddress',
      style: styles
    },
    {
      Header: translation('supplierDataChange_columnActions'),
      width: 160,
      sortable: false,
      style: styles,
      Cell: ({ original }) => {
        const isCouponActive =
          !original.couponDeadline ||
          new Date(original.couponDeadline).getTime() > Date.now();

        if (original.couponId && !original.requestFormId && isCouponActive) {
          return (
            <Button
              variant="contained"
              color="secondary"
              size="small"
              onClick={() => onChangeAddress(original)}
            >
              {translation('supplierDataChange_changeAddress')}
            </Button>
          );
        }
        return original.isActive && !original.requestFormId ? (
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => onAnnul(original)}
          >
            {translation('supplierDataChange_revoke')}
          </Button>
        ) : null;
      }
    }
  ];
};
